module.exports = __webpack_public_path__ + "img/globe.cf8987d5.png";